import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js';
import { EXCLUDED_PHONE_COUNTRIES, FAVORITE_PHONE_COUNTRIES } from './constants';
import { IPhoneCountryOption } from './types';

export function buildPhoneCountryOptions(locale: string): {
  favoriteCountries: IPhoneCountryOption[];
  otherCountries: IPhoneCountryOption[];
} {
  const displayNames = new Intl.DisplayNames([locale], { type: 'region' });
  const toOption = (code: CountryCode): IPhoneCountryOption => ({
    code,
    name: displayNames.of(code) ?? code,
    callingCode: `+${getCountryCallingCode(code)}`,
  });

  const availableCountries = getCountries().filter(
    (code) => !EXCLUDED_PHONE_COUNTRIES.includes(code)
  );

  const favoriteCountries = FAVORITE_PHONE_COUNTRIES.filter((code) =>
    availableCountries.includes(code)
  ).map(toOption);

  const otherCountries = availableCountries
    .filter((code) => !FAVORITE_PHONE_COUNTRIES.includes(code))
    .map(toOption)
    .sort((a, b) => a.name.localeCompare(b.name));

  return { favoriteCountries, otherCountries };
}

export function getPhoneCallingCode(country: CountryCode): string {
  return `+${getCountryCallingCode(country)}`;
}

export function getFlagUrl(country: CountryCode): string {
  return `./assets/flags/4x3/${country.toLowerCase()}.svg`;
}
